import { z } from 'zod';

/**
 * Zod ohne `new Function` (Prüfstufe F14): Die CSP der App verbietet eval; Zod prüft sonst beim Start, ob es Code
 * erzeugen darf, und Firefox meldet jeden Versuch als CSP-Fehler. Muss vor allen Schemas geladen werden (main.tsx).
 */
z.config({ jitless: true });
